import { AssertionError } from 'src/errors/assert';

export function assert<TCondition>(condition: TCondition, message?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message);
  }
}
